import {
	GET_TO_EMAILS_LIST_REQUEST,
	GET_TO_EMAILS_LIST_SUCCESS,
	GET_TO_EMAILS_LIST_FAILED,
	GET_TO_EMAILS_LIST_RESET,
	GET_FROM_EMAILS_LIST_REQUEST,
	GET_FROM_EMAILS_LIST_SUCCESS,
	GET_FROM_EMAILS_LIST_FAILED,
	GET_FROM_EMAILS_LIST_RESET,
	GET_USERS_LIST_REQUEST,
	GET_USERS_LIST_SUCCESS,
	GET_USERS_LIST_FAILED,
	GET_USERS_LIST_RESET,
	GET_SOURCES_LIST_REQUEST,
	GET_SOURCES_LIST_SUCCESS,
	GET_SOURCES_LIST_FAILED,
	GET_SOURCES_LIST_RESET,
	GET_RETAIN_FILTERS_LIST_REQUEST,
	GET_RETAIN_FILTERS_LIST_SUCCESS,
	GET_RETAIN_FILTERS_LIST_FAILED,
	GET_RETAIN_FILTERS_LIST_RESET,
	GET_INFO,
	GET_INFO_SUCCESS,
	GET_REVIEW_OVERVIEW_DETAILS_REQUEST,
	GET_REVIEW_OVERVIEW_DETAILS_SUCCESS,
	GET_REVIEW_OVERVIEW_DETAILS_FAILED,
	GET_REVIEW_OVERVIEW_DETAILS_RESET,
	GET_USER_REVIEW_OVERVIEW_DETAILS_REQUEST,
	GET_USER_REVIEW_OVERVIEW_DETAILS_SUCCESS,
	GET_USER_REVIEW_OVERVIEW_DETAILS_FAILED,
	GET_USER_REVIEW_OVERVIEW_DETAILS_RESET,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_SUCCESS,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_FAILED,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_RESET,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_SUCCESS,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_FAILED,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_RESET,
} from "../types"

/****************Ragnar Lodbrok****************/

//get From Emails list

export const getFromEmails = (data) => ({
	type: GET_FROM_EMAILS_LIST_REQUEST,
	payload: data,
})

export const getFromEmailsSuccess = (data) => ({
	type: GET_FROM_EMAILS_LIST_SUCCESS,
	payload: data,
})

export const getFromEmailsFailed = (data) => ({
	type: GET_FROM_EMAILS_LIST_FAILED,
	payload: data,
})

export const getFromEmailsReset = () => ({
	type: GET_FROM_EMAILS_LIST_RESET,
})

//get To Emails list

export const getToEmails = (data) => ({
	type: GET_TO_EMAILS_LIST_REQUEST,
	payload: data,
})

export const getToEmailsSuccess = (data) => ({
	type: GET_TO_EMAILS_LIST_SUCCESS,
	payload: data,
})

export const getToEmailsFailed = (data) => ({
	type: GET_TO_EMAILS_LIST_FAILED,
	payload: data,
})

export const getToEmailsReset = () => ({
	type: GET_TO_EMAILS_LIST_RESET,
})

//get users list
export const getUsers = (data) => ({
	type: GET_USERS_LIST_REQUEST,
	payload: data,
})

export const getUsersSuccess = (data) => ({
	type: GET_USERS_LIST_SUCCESS,
	payload: data,
})

export const getUsersFailed = (data) => ({
	type: GET_USERS_LIST_FAILED,
	payload: data,
})

export const getUsersReset = () => ({
	type: GET_USERS_LIST_RESET,
})

//get Sources list
export const getSources = (data) => ({
	type: GET_SOURCES_LIST_REQUEST,
	payload: data,
})

export const getSourcesSuccess = (data) => ({
	type: GET_SOURCES_LIST_SUCCESS,
	payload: data,
})

export const getSourcesFailed = (data) => ({
	type: GET_SOURCES_LIST_FAILED,
	payload: data,
})

export const getSourcesReset = () => ({
	type: GET_SOURCES_LIST_RESET,
})

//get Retain Filters list from job
export const getRetainFiltersList = (data) => ({
	type: GET_RETAIN_FILTERS_LIST_REQUEST,
	payload: data,
})

export const getRetainFiltersSuccess = (data) => ({
	type: GET_RETAIN_FILTERS_LIST_SUCCESS,
	payload: data,
})

export const getRetainFiltersFailed = (data) => ({
	type: GET_RETAIN_FILTERS_LIST_FAILED,
	payload: data,
})

export const getRetainFiltersReset = () => ({
	type: GET_RETAIN_FILTERS_LIST_RESET,
})
export const getInfo = () => ({
	type: GET_INFO,
	payload: {},
})

export const getInfoSuccess = (data) => ({
	type: GET_INFO_SUCCESS,
	payload: data,
})

export const getInfoFailed = (data) => ({
	type: GET_SOURCES_LIST_FAILED,
	payload: data,
})

// get review overview details

export const getReviewOverviewDetails = (data) => ({
	type: GET_REVIEW_OVERVIEW_DETAILS_REQUEST,
	payload: data,
})

export const getReviewOverviewDetailsSuccess = (data) => ({
	type: GET_REVIEW_OVERVIEW_DETAILS_SUCCESS,
	payload: data,
})

export const getReviewOverviewDetailsFailed = (data) => ({
	type: GET_REVIEW_OVERVIEW_DETAILS_FAILED,
	payload: data,
})

export const getReviewOverviewDetailsReset = () => ({
	type: GET_REVIEW_OVERVIEW_DETAILS_RESET,
})

// get user review overview details

export const getUserReviewOverviewDetails = (data) => ({
	type: GET_USER_REVIEW_OVERVIEW_DETAILS_REQUEST,
	payload: data,
})

export const getUserReviewOverviewDetailsSuccess = (data) => ({
	type: GET_USER_REVIEW_OVERVIEW_DETAILS_SUCCESS,
	payload: data,
})

export const getUserReviewOverviewDetailsFailed = (data) => ({
	type: GET_USER_REVIEW_OVERVIEW_DETAILS_FAILED,
	payload: data,
})

export const getUserReviewOverviewDetailsReset = () => ({
	type: GET_USER_REVIEW_OVERVIEW_DETAILS_RESET,
})

//Dyanamic emails from list

export const getDynamicFromEmails = (data) => ({
	type: GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST,
	payload: data,
})

export const getDynamicFromEmailsSuccess = (data) => ({
	type: GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_SUCCESS,
	payload: data,
})

export const getDynamicFromEmailsFailed = (data) => ({
	type: GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_FAILED,
	payload: data,
})

export const getDynamicFromEmailsReset = () => ({
	type: GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_RESET,
})

//Dyanamic emails to list

export const getDynamicToEmails = (data) => ({
	type: GET_DYNAMIC_TO_EMAILS_LIST_REQUEST,
	payload: data,
})

export const getDynamicToEmailsSuccess = (data) => ({
	type: GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_SUCCESS,
	payload: data,
})

export const getDynamicToEmailsFailed = (data) => ({
	type: GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_FAILED,
	payload: data,
})

export const getDynamicToEmailsReset = () => ({
	type: GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_RESET,
})
